import {createAction} from 'typesafe-actions';

import {
  type RunFieldsFragment,
  type RunSelectorRunsQuery,
} from '../../generated/graphql';
import type * as RunTypes from '../../util/runTypes';
export {deleteRun, updateRun, updateRunTags} from '../runs-low/actions';

export type RunSelectorRunsData = {
  lastUpdatedAt: string;
  runs: RunTypes.Run[];
  totalRuns: number;
  pinnedRuns: RunTypes.Run[];
};

type ProjectResult = NonNullable<NonNullable<RunSelectorRunsQuery['project']>>;
type QueryResultsData = {
  runs: {
    delta: NonNullable<ProjectResult['runs']>['delta'];
    totalCount: number;
    deltaOrder: string[];
  };
  pinnedRuns: RunFieldsFragment[] | null;
};

export const processQueryResults = createAction(
  '@runSelectorRuns/processQueryResults',
  action =>
    (
      queryId: string,
      requestedPinnedRunIds: string[],
      data: QueryResultsData
    ) =>
      action({queryId, requestedPinnedRunIds, data})
);

export const removeQuery = createAction(
  '@runSelectorRuns/removeQuery',
  action => (queryId: string) => action({queryId})
);

export const loadRunSelectorRunsFromCache = createAction(
  '@runSelectorRuns/loadRunSelectorRunsFromCache',
  action => (queryId: string, data: RunSelectorRunsData) =>
    action({queryId, data})
);
